// Backend-surface detection — which SERVER this bundle is deployed against.
//
// Two bundles exist, and each is physically paired with its backend:
//   'desktop' — the renderer bundle, served by the local Hono server. Reached
//               from the Electron window or the phone over the relay — both
//               talk to the SAME full desktop backend.
//   'cloud'   — the apps/cloud-web bundle, served by the Cloudflare Worker
//               (app.onestoneai.com) with the worker's reduced /api surface.
//
// This is deliberately a BUILD-TIME constant (Vite `define` in
// apps/cloud-web/vite.config.ts sets VITE_BACKEND_SURFACE='cloud'; every other
// build defaults to 'desktop'), not a runtime probe: the bundle↔backend pairing
// is fixed at deploy time, so a define can never drift and costs no fetch.
//
// Distinct from isElectron() (lib/electron.ts), which detects the CLIENT
// runtime (preload bridge present) and governs only client-side capabilities —
// IPC, clipboard, the in-process updater. Using isElectron() to infer the
// backend is the bug class that broke the relay PWA: a phone browser on the
// relay is a non-Electron CLIENT talking to the full desktop BACKEND, and
// isElectron() gates wrongly routed it to cloud-only panels whose endpoints
// don't exist on the desktop server (root-caused 2026-09-24).
export type BackendSurface = 'desktop' | 'cloud';

export function backendSurface(): BackendSurface {
  return import.meta.env.VITE_BACKEND_SURFACE === 'cloud' ? 'cloud' : 'desktop';
}

/** True when this bundle talks to the Cloudflare Worker backend (app.onestoneai.com). */
export function isCloud(): boolean {
  return backendSurface() === 'cloud';
}

/** True when this bundle talks to the full local desktop server — from the
 *  Electron window or the phone over the relay alike. */
export function isDesktopBackend(): boolean {
  return backendSurface() === 'desktop';
}
